import { Form, useNavigation } from 'react-router-dom';
import { BlockAlert } from '@mosey/components/layout/BlockAlert';
import { TextLink } from '@mosey/components/navigation/TextLink';
import {
  useIsBulkQuestion,
  useTask,
  useTaskActionData,
  useTaskSourceQuestion,
} from '../../utils/hooks';
import { TaskActions } from '../../common/TaskActions';
import { SkipButton } from '../../common/SkipButton';
import { SubmitButton } from '../../common/SubmitButton';
import { TaskQuestionField } from './TaskQuestionField';
import { StandaloneTaskPlatformReturnLink } from '../../common/StandaloneTaskPlatformReturnLink';

export const TaskQuestionUnanswered = () => {
  const { state } = useNavigation();
  const { id } = useTask();
  const source = useTaskSourceQuestion();
  const { description, form } = source;
  const isBulkQuestion = useIsBulkQuestion();
  const actionData = useTaskActionData();
  const formId = `task-question-form_${id}`;

  return (
    <>
      <div className="mt-4 flex flex-col gap-y-4">
        <BlockAlert
          variant="error"
          message={
            <>
              {actionData?.errors?.submit &&
                actionData.errors.submit
                  .split(/(contact support)/)
                  .map((s, index) => {
                    if (s === 'contact support') {
                      return (
                        <TextLink
                          key={index}
                          to="mailto:support@mosey.com"
                          target="_blank"
                        >
                          contact support
                        </TextLink>
                      );
                    }
                    return s;
                  })}
            </>
          }
          scrollIntoView
          show={!!actionData?.errors?.submit && state === 'idle'}
          aria-live="assertive"
        />

        {description && <p className="max-w-3xl">{description}</p>}

        <Form id={formId} method="POST" replace>
          {form.sections.map((section) => {
            return section.form_fields.map((field) => {
              return <TaskQuestionField field={field} key={field.name} />;
            });
          })}
        </Form>
      </div>

      <TaskActions>
        <StandaloneTaskPlatformReturnLink />

        <SkipButton />

        <SubmitButton
          form={formId}
          intent={isBulkQuestion ? 'bulk-answer' : 'answer-question'}
        >
          Save & continue
        </SubmitButton>
      </TaskActions>
    </>
  );
};
